import { useQuery } from "@apollo/client";
import { MOBILE_TAGS_QUERY } from "Services/queries";
import { useWithDefaultParams } from "Services/useWithDefaultParams";

export const useGetBeautyTagsQuery = () => {
	const { params } = useWithDefaultParams();

	const mobileTagsQuery = useQuery(MOBILE_TAGS_QUERY, {
		variables: {
			region_url: params.regionUrl,
			provider_url: params.operator,
			tag_type: "beauty",
		},
		notifyOnNetworkStatusChange: true,
	});

	return {
		mobileTags: mobileTagsQuery?.data?.mobileTags?.data,
		isLoading: mobileTagsQuery.loading,
	};
};
